// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper__Dhy3G","menu":"menu__27I5U","shown":"shown__pWYjO","itemsWrapper":"itemsWrapper__+N4GM","item":"item__djOhq"};